'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var theme_common_tokens_borders = require('./tokens/borders.js');
var theme_common_tokens_typography = require('./tokens/typography.js');
var theme_common_primitives_commonPrimitives = require('./primitives/commonPrimitives.js');
var theme_common_tokens_spacing = require('./tokens/spacing.js');
var theme_common_primitives_defaultPrimitives = require('./primitives/defaultPrimitives.js');
var theme_common_tokens_breakpoints = require('./tokens/breakpoints.js');
require('@babel/runtime/helpers/toConsumableArray');
require('@babel/runtime/helpers/defineProperty');
require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);

function getTheme(_ref) {
  var _ref$consumerName = _ref.consumerName,
    consumerName = _ref$consumerName === void 0 ? 'all' : _ref$consumerName,
    fonts = _ref.fonts,
    colors = _ref.colors,
    _ref$values = _ref.values,
    values = _ref$values === void 0 ? {} : _ref$values;
  var sizes = theme_common_tokens_spacing.getSizeTokens(values.sizes);
  return _objectSpread__default["default"](_objectSpread__default["default"](_objectSpread__default["default"](_objectSpread__default["default"]({
    consumerName: consumerName,
    colors: _objectSpread__default["default"](_objectSpread__default["default"]({}, colors), theme_common_primitives_commonPrimitives.commonColors),
    shadows: values.shadows || theme_common_primitives_defaultPrimitives.defaultShadowPrimitives,
    sizes: sizes,
    space: theme_common_tokens_spacing.getSpaceTokens(sizes),
    transitionTimingFn: values.transitionTimingFn || theme_common_primitives_defaultPrimitives.defaultTransitionTimingFn
  }, theme_common_tokens_borders.getAllBorders({
    colorTokens: colors,
    borderWidthPrimitives: values.borderWidths,
    sizes: sizes
  })), theme_common_tokens_typography.getAllTypography({
    fonts: fonts,
    fontSizePrimitives: values.fontSizes,
    fontWeights: values.fontWeights,
    lineHeights: values.lineHeights,
    letterSpacings: values.letterSpacings
  })), theme_common_tokens_breakpoints.getAllMedia(values.breakpoints)), theme_common_primitives_commonPrimitives.commonPrimitives);
}

exports.getTheme = getTheme;
//# sourceMappingURL=getTheme.js.map
